import api from "./apiClient";

export async function ForgotPass(email) {
	const response = await api.post("/forgot-password", {
		email: email,
	}, {
		skipAuth: true  // Forgot password endpoint doesn't require authentication
	});
	return response;
}